import fr from 'facet-rest';
import DetailItems from 'Views/Page/Content/Modal/Layouts/DefaultStep/Layout/DetailItems';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import CollectionViewer from './Content/CollectionViewer';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .typeOverride('collection', {
    _component: () => CollectionViewer,
    _spreadPropNames: ['resource', 'attrName'],
  }, { ordinal: 200 })
  .nameOverride('detailItems', {
    _component: () => DetailItems,
    _spreadPropNames: ['resource', 'attrName'],
  }, { ordinal: 200 });
